import { Map, fromJS } from "immutable";
import * as actionTypes from "~/store/action_types";

const featurePointers = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_FEATURE_POINTERS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { featurePointers = {} } = entities;

      return state.merge(fromJS(featurePointers));
    }
    case actionTypes.DISMISS_FEATURE_POINTER_SUCCESS: {
      const { featurePointerId = null } = action;
      if (featurePointerId) {
        return state.delete(`${featurePointerId}`);
      }
      return state;
    }
    default:
      return state;
  }
};

export default featurePointers;
